import React,{useState,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { get, post } from '../../util/axiosConfig/AxiosConfig';
import showAlert from "../alert/Alert";

const SubscriptionItem = (props) => {
    const { id, type, amount, features, validity, shortCourse } = props;
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const managePlan = () => {
        localStorage.setItem('cartData', JSON.stringify(props));
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(userObj.existingFlag == true){
            // redirectToLoginPage();
            addtoCart(userObj.userId, id, localStorage.getItem('unit'));
            showAlert('', 'Item added to your cart successfully', 'success', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
        }else{
            navigate('/CreateAccount')
        }
    }

    const continueShopping = (value) => {
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(value === true){
            navigate('/Home?id='+userObj.userId);
        }
    }

    const proceedToCheckout = (value) => {
        if(value === true){
            redirectToLoginPage();
        }
    }

    

    const redirectToLoginPage = () => {
        window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app/NewDashboard`, '_blank');
    }



    const addtoCart = async (userId, planId,unitId ) => {
        try {
            setLoading(true);
            const response = await get(`web/api/v1/lms-web/register/cart?userId=${userId}&planId=${planId}&unitId=${unitId}`);
        } catch (error) {
            setLoading(false);
            showAlert('', 'Selected plan already exists in your account.', 'error', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    // const managePlan = () => {
    //     const existingCartData = JSON.parse(localStorage.getItem('cartData')) || [];
    //     const updatedCartData = [...existingCartData, id];
    //     localStorage.setItem('cartData', JSON.stringify(updatedCartData));
    //     navigate('/CreateAccount');
    // };

    return (
        <React.Fragment>
            <div className="subscription_item_main">
                <div className="container">
                    <div className="subscription_box_main">
                        <div className="subscription_item">
                            <div className="subscription_type">
                                <p className="subscription_type_text">{type}</p>
                            </div>
                            <div className="subscription_amount">
                                <p className="subscription_amount_text">₹ {amount}</p>
                                <p className="time_frame">Validity: {validity} days </p>
                            </div>
                            <div className="subscription_features">
                                <ul className="subscription_features_ul">
                                    {/* {features.map((feature, index) => (
                                        <li key={index} className="subscription_features_li">
                                            <div className="subscription_features_text_main">
                                                <span className={`tick_icon ${feature.active === 'active' ? '' : 'mute_icon'}`}>
                                                    <i className={`fa-regular ${feature.active === 'active' ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                </span>
                                                <p className={`subscription_features_text ${feature.active === 'inactive' ? 'strike' : ''}`}>
                                                    {feature.name}
                                                </p>
                                            </div>
                                        </li>
                                    ))} */}

                                    {features.map((feature, index) => (
                                        <li key={index} className="subscription_features_li">
                                            <div className="subscription_features_text_main">
                                                <span className={`tick_icon ${feature.active == true ? '' : 'mute_icon'}`}>
                                                    <i className={`fa-regular ${feature.active == true ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                </span>
                                                <p className={`subscription_features_text ${feature.active === 'inactive' ? 'strike' : ''}`}>
                                                    {feature.name}
                                                </p>
                                            </div>
                                        </li>
                                    ))}


                                    {/* <li className="subscription_features_li">
                                        <div className="subscription_features_text_main">
                                            <span className="tick_icon"><i class="fa-regular fa-circle-check"></i></span>
                                            <p className="subscription_features_text">15 Days Duration</p>
                                        </div>
                                    </li>
                                    <li className="subscription_features_li">
                                        <div className="subscription_features_text_main">
                                            <span className="tick_icon"><i class="fa-regular fa-circle-check"></i></span>
                                            <p className="subscription_features_text">15 Days Duration</p>
                                        </div>
                                    </li>
                                    <li className="subscription_features_li">
                                        <div className="subscription_features_text_main">
                                            <span className="tick_icon"><i class="fa-regular fa-circle-check"></i></span>
                                            <p className="subscription_features_text">15 Days Duration</p>
                                        </div>
                                    </li>
                                    <li className="subscription_features_li">
                                        <div className="subscription_features_text_main">
                                            <span className="tick_icon"><i class="fa-regular fa-circle-check"></i></span>
                                            <p className="subscription_features_text">15 Days Duration</p>
                                        </div>
                                    </li>
                                    <li className="subscription_features_li">
                                        <div className="subscription_features_text_main">
                                            <span className="tick_icon mute_icon"><i class="fa-regular fa-circle-xmark"></i></span>
                                            <p className="subscription_features_text strike">15 Days Duration</p>
                                        </div>
                                    </li> */}
                                </ul>
                                <div className="subscription_card_btn_area">
                                    <button className="chose_plan_btn" onClick={()=>managePlan()}>{shortCourse == "Short" ? "Select" : "Choose Plan"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default SubscriptionItem;